import { gql } from '@apollo/client';
import Page from 'components/Page';
import StatusTag from 'components/StatusTag';
import Table from 'components/Table';
import { useQuery } from 'hooks/apollo';
import React from 'react';

const QUERY = gql`
  query {
    autoTaggings {
      id
      createdAt      
      createdBy {
        id
        email 
      }
      status
      autoTags {
        id
      }
      question {
        id
        title
        survey {
          id
          title
          customer {
            id
            name
          }
        }
      }
    }
  }
`;

const columns = [{
  title: 'Date',
  dataIndex: 'createdAt',
  type: 'date',
  defaultSortOrder: 'descend',
}, {
  title: 'Account',
  dataIndex: ['question', 'survey', 'customer', 'name'],
}, {
  title: 'Survey',
  dataIndex: ['question', 'survey', 'title'],
}, {
  title: 'Question',
  dataIndex: ['question', 'title'],
}, {
  title: 'Created by',
  dataIndex: ['createdBy', 'email'],
}, {
  title: 'Auto tags',
  dataIndex: 'autoTags',
  render: (autoTags) => autoTags.length,
}, {
  title: 'Status',
  dataIndex: 'status',
  render: (status) => <StatusTag status={status} />,
}];

const AutoTaggings = () => {
  const { data, loading } = useQuery(QUERY);

  return (
    <Page>
      <Page.Header title="Auto taggings" />
      <Page.Content>
        <Table dataSource={data?.autoTaggings} loading={loading} columns={columns} />
      </Page.Content>
    </Page>
  );
};

export default AutoTaggings;
